import { REGEX } from '../../util/constants';
import { VALIDATION_ERROR_MESSAGES } from './errorMessages';

const { EMAIL, ACCOUNT_NUMBER, LANDLINE_NUMBER } = REGEX;
const {
  invalidEmail,
  invalidPassword,
  invalidAccountNumber,
  invalidLandlineNumber,
  accountNumberRequired,
  landlineNumberRequired,
} = VALIDATION_ERROR_MESSAGES;

/**
 * @name validateEmail - Function validate email id field
 * @param {string} email - User input email Id
 * @returns {string} - Validted Email
 */
export const validateEmail = email => {
  if (!email) return null;
  if (!EMAIL.test(email)) return invalidEmail;
  return null;
};

/**
 * @name validatePassword - Function validate password field
 * @param {string} password - User input password
 * @returns {string}- Validated Password
 */
export const validatePassword = password => {
  if (!password) return null;
  if (password?.length < 6) return invalidPassword;
  return null;
};

/**
 * @name validateAccountNumber - Function validate account number field
 * @param {string} accountNumber - User input account number
 * @returns {string} - Validated Account Number
 */
export const validateAccountNumber = accountNumber => {
  if (!accountNumber) return accountNumberRequired;
  if (!ACCOUNT_NUMBER.test(accountNumber)) return invalidAccountNumber;
  if (accountNumber.length > 24) return invalidAccountNumber;
  return null;
};

/**
 * @name validateLandlineNumber - Function validate mobile/landline number field
 * @param {string} landLineNumber - User input mobile/landline number
 * @returns {string}- Validated mobile/landline number
 */
export const validateLandlineNumber = landLineNumber => {
  if (!landLineNumber) return landlineNumberRequired;
  if (!LANDLINE_NUMBER.test(landLineNumber)) {
    return invalidLandlineNumber;
  }
  if (landLineNumber.length > 4) return invalidLandlineNumber;
  return null;
};

/**
 * @name validateFields - Function validate fields on change
 * @param {object} errors - Validation failure errors
 * @param {object} values - User input values
 * @param {Function} setDisableCTA - Function to enable and disable CTA based on result
 */
export const validateFields = (errors, values, setDisableCTA) => {
  const noErrors = Object.values(errors).every(error => error === null);
  const noValues = Object.values(values).every(value => value.trim() !== '');
  if (noErrors && noValues) {
    setDisableCTA(false);
  } else {
    setDisableCTA(true);
  }
};
